export const menuHeight = 40;
export const subMenuHeight = 40;
export const sidebarWidth = 280;
export const closedSidebarWidth = 64;
export const sidebarAnimation = '225ms cubic-bezier(0.4, 0, 0.6, 1) 30ms';